import React, { useState } from "react";
import "./ProfitLoss.css";

const ProfitLoss = () => {

  return (
    <div className="profitLoss-container">
      {/* Page Title */}
      <h1 className="profitLoss-title">Profit - Loss</h1>

      {/* Filter Section */}
      <div className="profitLoss-filterBox">
        <div className="profitLoss-filter-title">Filter By</div>
        <div className="profitloss-filter-item-div">
          <div className="profitloss-filter-item">
            <label>Branch</label>
            <select>
              <option value="">Select Branch</option>
              <option value="Bareilly">Bareilly</option>
              <option value="Delhi">Delhi</option>
              <option value="Mumbai">Mumbai</option>
            </select>
          </div>

          <button className="profitloss-filter-btn">Filter</button>
        </div>
      </div>

      {/* Layout: Income Left | Expense Right */}
      <div className="profitLoss-report-container">
        <h2 className="profitLoss-section-title">Profit Loss</h2>
        <div className="profitLoss-report-section">
        {/* Income Section */}
        <div className="profitLoss-income-section">
          <h2>Income</h2>
          <p>Indirect Income: 18607.00</p>
          <div className="profitLoss-income-box">
            <table>
              <tr>
                <td>1</td>
                <td>Interest(Income)</td>
                <td>
                  <div className="income-td-div">
                    <h2>Branch: Braily</h2>
                    <div className="income-td-data">
                      <p>Opening Balance: 0</p>
                      <p>DR: 0</p>
                      <p>CR: 0</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>File Charge</td>
                <td>
                  <div className="income-td-div">
                    <h2>Branch: Braily</h2>
                    <div className="income-td-data">
                      <p>Opening Balance: 0</p>
                      <p>DR: 0</p>
                      <p>CR: 0</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Processing Fee</td>
                <td>
                  <div className="income-td-div">
                    <h2>Branch: Braily</h2>
                    <div className="income-td-data">
                      <p>Opening Balance: 0</p>
                      <p>DR: 0</p>
                      <p>CR: 0</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>Loan Sattlement P & L</td>
                <td></td>
              </tr>
              <tr>
                <td>5</td>
                <td>Sattlement Charges</td>
                <td></td>
              </tr>
              <tr>
                <td>6</td>
                <td>Penalty Charges</td>
                <td></td>
              </tr>
              <tr>
                <td>7</td>
                <td>Unknown4</td>
                <td></td>
              </tr>
              <tr>
                <td>8</td>
                <td>Previous Collection</td>
                <td></td>
              </tr>
            </table>
          </div>
        </div>

        {/* Expense Section */}
        <div className="profitLoss-expense-section">
          <h2>Expense</h2>
          <p>Indirect Expense: 0.00</p>
          <div className="profitLoss-expense-box">
            <table>
              <tr>
                <td>1</td>
                <td>Salary</td>
                <td>
                  <ul>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>RD Interest Payout</td>
                <td>
                  <ul>
                    <li>Head Office JMC</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>RD Payout</td>
                <td>
                  <ul>
                    <li>Head Office JMC</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>Electricity Bill</td>
                <td>
                  <ul>
                    <li>Head Office JMC</li>
                    <li>Head Office JMC</li>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
        </div>
        </div>

      </div>
    </div>
  );
};

export default ProfitLoss;
